// extracted by mini-css-extract-plugin
module.exports = {"error":"#ff4040","success":"#28cb93","primary-color":"#00bfb2","dark-grey-color":"#444","spinner":"Loader_spinner__odVZ-","rotate":"Loader_rotate__1x2dN"};